import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=37e0d0a2&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e0d0a2')) {
      api.createRecord('37e0d0a2', component.options)
    } else {
      api.reload('37e0d0a2', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=37e0d0a2&", function () {
      api.rerender('37e0d0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/functional/Breadcrumbs.vue"
export default component.exports